import { AdminSideBar } from "./AdminSideBar.tsx";
import { PropsWithChildren } from "react";

export function AdminMainContainer({ children }: PropsWithChildren) {
  return (
    <div className={"flex flex-1 max-w-full"}>
      <AdminSideBar />
      <div className={"flex-1 flex-col flex max-w-full min-w-0"}>
        {children}
      </div>
    </div>
  );
}
